module.exports = __webpack_public_path__ + "avatar-placeholder.a571e962de5384ed60d70276faf7ee3b.hashedasset.svg";